import script from "./MediaGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaGallery.vue?vue&type=script&setup=true&lang=js"

import "./MediaGallery.vue?vue&type=style&index=0&id=8c3dbe44&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c3dbe44"]])

export default __exports__